<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <div class="col-12 col-md-10">
                <TitleComponent title="2. Tus entradas" subtitle="Completa la información necesaria para cada uno de los abonos seleccionados"/>
            </div>
            <div class="pr-0 mb-3 col-12 col-md-2">
                <Button @click.prevent="volver" :disabled="disableInput">Cambiar butacas</Button>
            </div>
            <div class="mt-3 col-12" v-if="datos_compradores.length > 0">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" v-model="select_all" id="select_all" :disabled="disableInput"/>
                    <label class="custom-control-label" for="select_all">Seleccionar todas las entradas</label>
                </div>
            </div>
            <div class="mt-3 col-12">
                <div class="form-group">
                    <label for="concepto">Concepto</label>
                    <small>Este texto irá incluido en la entrada, máximo 15 caracteres</small>
                    <input maxlength="15" type="text" name="concepto" class="form-control rounded-pill" id="concepto" placeholder="Concepto" v-model="concepto" :disabled="disableInput"/>
                </div>
            </div>
            <div class="mt-3 col-12">
                <FormInput label="CP/ZIP CODE" minlength="5" maxlength="10" name="cc" id="cp" v-model="cp" :disabled="disableInput"/>
            </div>
            <b-col class="mt-3">
                <label for="telefono">Teléfono</label>
                <PhoneInput
                    :phone="telefono"
                    :desactivar="disableInput"
                    :required="enviar_whatsapp"
                    :error_telefono="enviar_whatsapp"
                    :forceValidate="forceValidatePhone"
                    @validNumber="(valid) => isValidNumber = valid"
                    @setNumber="setNumber"
                />
            </b-col>
            <template v-if="teatro.solicitar_datos_comprador_taquilla">
                <FormInput class="col-6" label="Nombre" name="nombre" id="nombre" v-model="nombre_comprador" rules="required" />
                <FormInput class="col-6" label="Apellidos" name="apellidos" id="apellidos" v-model="apellidos_comprador" rules="required" />
                <FormInput class="col-6" label="DNI" name="dni" id="dni" v-model="dni_comprador" rules="required" />
                <FormInput class="col-6" label="Teléfono" maxlength="9" name="telefono" id="telefono" type="number" v-model="telefono_comprador" rules="required" />
            </template>
            <div class="mt-4 col-12" v-if="datos_compradores.length > 0">
                <div class="row" id="entradas-seleccionadas">
                    <template v-for="(entrada, index) in datos_compradores">
                        <div :class="'col-12 ' + (datos_compradores.length > 2 ? 'col-md-4' : 'col-md-6')" :key="index">
                            <DatosEntradasComponent
                                :entrada="entrada"
                                :generos="generos"
                                :disableInput="disableInput"
                                :index="index"
                                :abonado="abonado"
                                :key="getEntradaKey(index)"
                                :fields="evento.fields"
                                :solicitar_datos="solicitar_datos"
                                v-on:actualizado="(error, entradaActualizada) => actualizar(index, error, entradaActualizada)"
                            />
                        </div>
                    </template>
                </div>
            </div>
            <div class="mb-3 col-12">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" v-model="enviar_email" id="enviar_email" :disabled="disableInput"/>
                    <label class="custom-control-label" for="enviar_email">Enviar por email</label>
                </div>
            </div>
            <div class="mb-3 col-12" v-if="enviar_email">
                <FormInput label="Email" name="email" id="email" rules="required|email" v-model="email" :disabled="disableInput"/>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="metodo_pago">Método de pago / Tipo de Impresión</label>
                    <ValidationProvider name="metodo_pago" rules="required" v-slot="{ errors }">
                        <select v-if="metodos_pago" v-model="metodo_pago" class="rounded-pill" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="metodo_pago" :disabled="disableInput">
                            <template v-for="(metodo, index) in metodos_pago">
                                <option :key="index" :value="metodo">{{ metodo.nombre }}</option>
                            </template>
                        </select>
                    </ValidationProvider>
                    <div
                        v-if="(metodo_pago && (metodo_pago.id === 6)) && !evento.place_obj"
                        class="mt-2 text-red"
                        role="alert"
                    >
                        Las invitaciones no se descontarán del total de entradas. Reduce el aforo de entradas a la venta si no lo has tenido en cuenta al crear los precios.
                    </div>
                </div>
            </div>
            <div class="mb-3 col-12" v-if="metodo_pago && (metodo_pago.nombre === 'INVITACIÓN' || metodo_pago.nombre === 'INVITACIÓN INFANTIL') && enviar_email">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" v-model="caducidad_entradas" id="caducidad_entradas"/>
                    <label class="custom-control-label" for="caducidad_entradas">Caducidad</label>
                </div>
            </div>
            <div class="mb-3 col-12" v-if="caducidad_entradas">
                <label for="fecha_fin">Fecha de caducidad</label>
                <ValidationProvider name="fecha_fin" rules="required" v-slot="{ errors }" mode="passive">
                    <datetime
                        v-model="fecha_caducidad"
                        :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                        type="datetime"
                        input-id="fecha_fin"
                        value-zone="Europe/Madrid"
                        :min-datetime="new Date().toISOString()"
                        :max-datetime="evento.end_event_date"
                    />
                    <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback"
                          style="display: block"
                    >{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="mb-3 col-12" v-if="!evento.place_id">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" v-model="visible" id="otros" :disabled="disableInput"/>
                    <label class="custom-control-label" for="otros">Entradas otros</label>
                </div>
                <div class="p-0 mt-3 mb-3 col-12">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" type="checkbox" v-model="enviar_whatsapp" id="enviar_whatsapp" :disabled="disableInput"/>
                        <label class="custom-control-label" for="enviar_whatsapp">Enviar por WhatsApp</label>
                    </div>
                    <div class="mt-2 mb-3 ml-0 col-12" v-if="enviar_whatsapp && !teatro.solicitar_datos_comprador_taquilla">
                        <FormInput label="Nombre" name="nombre" id="nombre" v-model="nombre_comprador" :disabled="disableInput"/>
                    </div>
                </div>
            </div>
            <div class="mb-5 col-12 mb-md-0">
                <DatosLegales :datos="datos_compradores[0]"/>
            </div>
            <div class="col-12" v-if="continuar">
                <Button type="submit" class="btn-block" :disabled="disableInput">CONTINUAR COMPRA</Button>
                <AvisoTpv v-if="esConTarjeta" :texto_aviso="evento.compania.texto_alerta_tpv" @close="closeModal()"/>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    import DatosEntradasComponent from '@/components/backend/stepper/components/DatosEntradasComponent';
    import DatosLegales from '@/components/backend/stepper/components/DatosLegales';
    import PhoneInput from '@/components/common/PhoneInput.vue';
    import AvisoTpv from './Modal/AvisoTpv';

    export default {
        props: {
            datos_compradores: {
                type: Array,
                required: true
            },
            solicitar_datos: {
                type: [Number, Boolean],
                required: false,
                default: false
            },
            sesion_id: {
                type: [Number, String],
                required: true
            },
            event_id: {
                type: [Number, String],
                required: true
            },
            carrito_id: {
                type: [Number, String],
                required: true
            },
            evento: {
                type: Object,
                required: true
            },
            abonado: {
                type: Object,
                required: false,
            },
            disableInput: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                concepto: null,
                cp: null,
                isValidNumber: false,
                nombre_comprador: null,
                apellidos_comprador: null,
                dni_comprador: null,
                telefono_comprador: null,
                select_all: null,
                enviar_email: null,
                email: null,
                nombre: null,
                telefono: null,
                metodo_pago: null,
                descuento: 0,
                es_invitacion: false,
                reloadComponent: 0,
                caducidad_entradas: false,
                fecha_caducidad: null,
                visible: 0,
                checkboxError: false,
                enviar_whatsapp: false,
                forceValidatePhone: false,
                currentlyEditingIndex: 0,
                isUpdatingAll: false,
            }
        },
        created() {
            window.addEventListener('beforeunload', this.volver);

            for (var i in this.datos_compradores) {
                if (this.evento.tiene_recinto) {
                    this.datos_compradores[i].descuento = 0;
                }
            }

            if (this.configuracion.hash_teatro === '5vL5WeAs3rdSehwve2zH') {
                if (!this.metodo_pago) {
                    this.metodo_pago = this.metodos_pago.find(metodo_pago => metodo_pago.id === 1);
                }
                setTimeout(() => {
                    this.datos_compradores.forEach(entrada => {
                        if (this.generos.length) {
                            this.$set(entrada, 'genero_id', this.generos.find(genero => genero.id === 3).id);
                        }
                    })
                }, 500);
            }

            this.datos_compradores.forEach(d => {
                this.$set(d, 'privacidad', true);
                this.$set(d, 'condiciones', true);
                this.$set(d, 'comunicaciones', true);
            });
        },
        beforeDestroy() {
            window.removeEventListener('beforeunload', this.volver);
        },
        watch: {
            descuento() {
                if(this.datos_compradores.length > 0) {
                    for(var i in this.datos_compradores) {
                        this.datos_compradores[i].descuento = this.descuento;
                    }
                }
            }
        },
        computed: {
            user() {
                return this.$store.getters.getUser;
            },
            metodos_pago() {
                const todos = (this.teatro && this.teatro.metodos_pago_eventos) || [];
                let metodos_de_pago = todos.slice().filter(metodo_pago => metodo_pago.show_taquilla);
                if (this.permisos['eventos.no_permitir_invitaciones']) {
                    metodos_de_pago = metodos_de_pago.slice().filter(metodo_pago => metodo_pago.id !== 6 && metodo_pago.id !== 10);
                }

                if (this.evento.compania) {
                    if (this.evento.compania.datafono_propio) {
                        const datafono = this.user.datafonos.find(datafono => datafono.nif === this.evento.compania.nif);
                        if (datafono) {
                            this.$store.dispatch('setPuedeUsarDatafono', true);
                        } else {
                            metodos_de_pago = metodos_de_pago.filter(metodo_pago => metodo_pago.id !== 3);
                        }
                    }
                }

                return metodos_de_pago;
            },
            continuar() {
                this.datos_compradores.forEach(entrada => {
                    if(entrada.precio == null) {
                        return false;
                    }
                });

                return true;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            permisos() {
                return this.$store.getters.getPermisos;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            esConTarjeta() {
                const nombresValidos = ['TARJETA', 'tarjeta', 'datafono', 'DATAFONO', 'datáfono', 'DATÁFONO'];

                if (this.evento.compania && this.evento.compania.alerta_tpv && this.metodo_pago && (this.metodo_pago.id === 3 && nombresValidos.includes(this.metodo_pago.nombre) || nombresValidos.includes(this.metodo_pago.nombre))) {
                    return true;
                }

                return false;
            },
            generos() {
                return this.$store.getters.getGeneros;
            }
        },
        methods: {
            goTo(paso) {
                var datos = {
                    cp: this.cp,
                    concepto: this.concepto,
                    nombre_comprador: this.nombre_comprador,
                    apellidos_comprador: this.apellidos_comprador,
                    dni_comprador: this.dni_comprador,
                    telefono_comprador: this.telefono_comprador,
                    enviar_email: this.enviar_email,
                    email: this.email,
                    nombre: this.nombre,
                    telefono: this.telefono,
                    metodo_pago: this.metodo_pago,
                    visible: this.visible,
                    fecha_caducidad: this.fecha_caducidad,
                };

                this.$emit('goTo', paso, datos, this.enviar_email);
            },
            actualizar(index, error, entradaActualizada) {
                if (this.isUpdatingAll) {
                    return;
                }

                this.currentlyEditingIndex = index;

                this.datos_compradores[index] = {
                    ...this.datos_compradores[index],
                    ...entradaActualizada,
                    checkboxError: error
                };

                if (this.datos_compradores[index].precio) {
                    this.es_invitacion = this.datos_compradores[index].precio.precio == 0;
                }

                if(this.es_invitacion) {
                    this.metodo_pago = this.metodos_pago.find(metodo_pago => metodo_pago.id == 6);
                }

                if(this.select_all) {
                    this.isUpdatingAll = true;

                    var genero_id = this.datos_compradores[index].genero_id;

                    if (this.datos_compradores[index].precio) {
                        var precio = this.datos_compradores[index].precio;
                    }

                    var descuento = this.datos_compradores[index].descuento;

                    var nombre = this.datos_compradores[index].nombre;

                    var apellidos = this.datos_compradores[index].apellidos;

                    var dni = this.datos_compradores[index].dni;

                    var properties = this.datos_compradores[index].properties;

                    for(var i in this.datos_compradores) {
                        if (i != index) {
                            this.datos_compradores[i].genero_id = genero_id;
                            // Only propagate `precio` when it belongs to the target entry's `precios` catalog.
                            // `actualizar` fires for any field change (descuento, nombre, precio, ...),
                            // so when the changed field is NOT the price we must not overwrite another
                            // entry's price with one that is not available in its own `precios` list.
                            if (precio && Array.isArray(this.datos_compradores[i].precios) &&
                                this.datos_compradores[i].precios.some(p => p && p.id === precio.id)) {
                                this.datos_compradores[i].precio = precio;
                            }
                            this.datos_compradores[i].descuento = descuento;
                            this.datos_compradores[i].nombre = nombre;
                            this.datos_compradores[i].apellidos = apellidos;
                            this.datos_compradores[i].dni = dni;
                            this.datos_compradores[i].properties = properties;
                        }
                    }

                    this.reloadComponent += 1;

                    this.$nextTick(() => {
                        this.isUpdatingAll = false;
                    });
                }
            },
            getEntradaKey(index) {
                if (this.currentlyEditingIndex === index) {
                    return "entrada-" + index;
                }
                return "entrada-" + index + "-reload-" + this.reloadComponent;
            },
            guardarDatos() {
                if(this.email) {
                    this.datos_compradores[0].email = this.email;
                }

                this.loading = true;

                var seats = {};
                for(var i in this.datos_compradores) {
                    if (this.datos_compradores[i].asiento === 0 && this.datos_compradores[i].fila === 0 && this.datos_compradores[i].zona_id) {
                        seats.asiento = this.datos_compradores[i].asiento;
                        seats.fila = this.datos_compradores[i].fila;
                        seats.zona_id = this.datos_compradores[i].zona_id;
                        this.datos_compradores[i].asiento = seats;
                    }
                }

                this.datos_compradores[0].enviar_whatsapp = this.enviar_whatsapp ? 1 : 0;

                const params = {
                    filters: {
                        sesion_id: this.sesion_id,
                        tid: this.configuracion.hash_teatro
                    },

                    evento_id: this.event_id,
                    datos_compradores: this.datos_compradores,
                    sesion_id: this.sesion_id,
                    tid: this.configuracion.hash_teatro,
                    session_id: this.carrito_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.guardar-datos-compradores'), params).then(res => {
                }).finally(() => this.loading = false);
            },
            async submit() {
                this.forceValidatePhone = true;
                const isValid = await this.$refs.observer.validate();
                this.checkboxError = this.datos_compradores.some(comprador => comprador.checkboxError === true);
                var errorTelefono = this.datos_compradores.some(comprador => !comprador.telefono);

                if (isValid && this.checkboxError === false && ((this.isValidNumber && !errorTelefono) || !this.enviar_whatsapp)) {

                    if (this.esConTarjeta) {
                        this.showModal();
                    }
                    this.guardarDatos();
                    this.goTo(4);
                } else {
                    this.$nextTick(() => {
                        const invalidElement = document.querySelector('.is-invalid, .invalid-feedback');
                        if (invalidElement) {
                            this.$scrollTo(invalidElement, 50, {
                                offset: -(window.innerHeight / 2)
                            });
                        }
                    });
                }
            },
            showModal() {
                this.$nextTick(() => {
                    this.$modal.show('aviso-tpv');
                });
            },
            closeModal() {
                this.$modal.hide('aviso-tpv');
            },
            setNumber(number) {
                if (this.datos_compradores.length > 0) {
                    this.datos_compradores.forEach(datos_comprador => {
                        datos_comprador.telefono = number;
                    });
                }
            },
            volver() {
                this.$emit('volver');
            }
        },
        components: {
            TitleComponent, DatosEntradasComponent, DatosLegales, PhoneInput, AvisoTpv
        }
    }
</script>
